/**
 * Returns the number of ISO 8601 weeks in the given year.
 * A year has 53 weeks when January 1st or December 31st falls on a Thursday.
 */
export function getISOWeeksInYear(year: number): number {
  const jan1 = new Date(year, 0, 1)
  const dec31 = new Date(year, 11, 31)
  return jan1.getDay() === 4 || dec31.getDay() === 4 ? 53 : 52
}

/**
 * Returns the ISO 8601 year and week number for the given date.
 *
 * The ISO year may differ from the calendar year at year boundaries
 * (e.g. Dec 31 can belong to ISO week 1 of the next year).
 */
export function getISOYearWeek(date: Date): { year: number; week: number } {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  )
  const dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  const week = Math.ceil(
    ((d.getTime() - yearStart.getTime()) / 86_400_000 + 1) / 7,
  )
  return { year: d.getUTCFullYear(), week }
}

function formatYearWeek({
  year,
  week,
}: {
  year: number
  week: number
}): string {
  return `${year}${week.toString().padStart(2, '0')}`
}

export function getCurrentYearWeek(date: Date = new Date()): string {
  return formatYearWeek(getISOYearWeek(date))
}

export function getYearWeekWeeksAgo({
  weeksAgo,
  today = new Date(),
}: {
  weeksAgo: number
  today?: Date
}): string {
  const shiftedDate = new Date(today)
  shiftedDate.setDate(shiftedDate.getDate() - weeksAgo * 7)
  return formatYearWeek(getISOYearWeek(shiftedDate))
}
